export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAIL = "FORGOT_PASSWORD_FAIL";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAIL = "RESET_PASSWORD_FAIL";
export const TWO_FA_EMAIL_SUCCESS = "TWO_FA_EMAIL_SUCCESS";
export const TWO_FA_RSEND_SUCCESS = "TWO_FA_RSEND_SUCCESS";
export const TWO_FA_EMAIL_FAIL = "TWO_FA_EMAIL_FAIL";
export const TWO_FA_RESEND_FAIL = "TWO_FA_RESEND_FAIL";

export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
export const PRELOGIN = "PRELOGIN";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
